<template>
    <div>
      <md-drawer class="md-right" :md-active.sync="showInfo" id="md-approve-dialog2" :md-fixed=true>
      <md-toolbar class="md-primary">
        <md-button class="md-icon-button" @click="showInfo = false">
          <md-icon >close</md-icon>
        </md-button>
        <div>{{Info.campaign_title}}</div>

        <div class="md-toolbar-section-end">
           <!-- <div class="sub-title">
              APPROVE
            </div> -->
              <md-menu md-align-trigger  v-if="isOwner && (permit.acl['campaign'].menus['manage'].edit == true || permit.acl['campaign'].menus['manage'].delete==true)">
                <md-button class="md-icon-button" md-menu-trigger>
                    <md-icon>more_vert</md-icon>
                </md-button>
                <md-menu-content>
                  <!-- <md-menu-item>Send to approve</md-menu-item> -->
                  <!-- <md-menu-item  disabled @click="data = 'click disabled'">Recall</md-menu-item> -->
                  <md-menu-item @click="editCampaign(Info._id)" v-if="permit.acl['campaign'].menus['manage'].edit == true && !Expired">Edit</md-menu-item>
                  <!-- <md-menu-item>Duplicate</md-menu-item> -->
                  <md-menu-item @click="duplicateCampaign(Info._id)" v-if="permit.acl['campaign'].menus['manage'].edit == true">Duplicate</md-menu-item>
                  <md-menu-item @click="sendApproveCampaign(Info._id)" v-if="permit.acl['campaign'].menus['manage'].edit == true && !Expired">Send Approve</md-menu-item>
                  <md-menu-item @click="recallCampaign(Info._id)" v-if="permit.acl['campaign'].menus['manage'].edit == true && !Expired">Recall</md-menu-item>

                  <md-menu-item @click="deleteCampaign(Info._id)" v-if="permit.acl['campaign'].menus['manage'].delete == true && !Expired">Delete</md-menu-item>

                </md-menu-content>
              </md-menu>
        </div>
      </md-toolbar>

        <div class="content-md-drawer">
              <md-card class="main-content" style="margin-top:24px;">
                    <md-card-header>
                      <md-card-header-text>
                        <div class="mktops-subheader-text">Basic Info <span class="campaign-status-label">{{Info.campaign_status}}</span></div>
                      </md-card-header-text>
                      <md-button class="md-button md-primary" @click="editCampaign(Info._id,1)" v-if="isOwner && permit.acl['campaign'].menus['manage'].add == true && !Expired">EDIT</md-button>
                    </md-card-header>
                    <div class="md-layout" style="padding-left:20px;padding-right:20px;">
                      <div class="md-layout-item md-size-5">
                        <div class="mktops-square-blue"><md-icon>show_chart</md-icon></div>
                      </div>
                      <div class="md-layout-item md-size-95" style="padding-left:10px">

                        <table class="mktops-info-table">
                          <tr>
                            <th class="md-tab-blue-text table" width="150">Campaign Code</th>
                            <th class="md-tab-blue-text table" width="150">Campaign Title</th>
                            <th class="md-tab-blue-text table">Campaign Detail</th>
                          </tr>
                          <tr>
                            <td>{{Info.campaign_code}}</td>
                            <td>{{Info.campaign_title}}</td>
                            <td>{{Info.campaign_detail}}</td>
                          </tr>
                          <tr>
                            <td class="md-tab-blue-text table">Start Date</td>
                            <td class="md-tab-blue-text table">End Date</td>
                            <td class="md-tab-blue-text table">Join Within</td>
                          </tr>
                          <tr>
                            <td>{{convertDate(Info.startdate)}}</td>
                            <td>{{convertDate(Info.enddate)}}</td>
                            <td>{{Info.join_within}} days</td>
                          </tr>
                        </table>
                      </div>
                    </div>
              </md-card>
              <md-card class="main-content" style="margin-top:12px;">
                <md-card-header>
                  <md-card-header-text>
                    <div class="mktops-subheader-text">Selected Products</div>
                  </md-card-header-text>
                  <md-button class="md-button md-primary" @click="editCampaign(Info._id,2)"  v-if="isOwner && permit.acl['campaign'].menus['manage'].add == true && !Expired">EDIT</md-button>
                </md-card-header>
                  <div class="mktops-produce-table" v-if="Info.products">
                    <md-table v-model="Info.products" md-fixed-header style="height: 200px;">
                      <md-table-row slot="md-table-row" slot-scope="{ item }">
                        <md-table-cell md-label="Code" md-sort-by="code">{{ item.code }}</md-table-cell>
                        <md-table-cell class="md-table-cell-description" md-label="Description" md-sort-by="description">{{ item.title_th }}</md-table-cell>
                        <md-table-cell md-label="Stock" md-sort-by="stock" style="text-align:center">-</md-table-cell>
                        <md-table-cell md-label="Unit" md-sort-by="unit" style="text-align:center">{{ item.unit }}</md-table-cell>
                        <md-table-cell md-label="Cost" md-sort-by="cost" md-numeric>{{ item.cost }}</md-table-cell>
                        <md-table-cell md-label="Price" md-sort-by="price" md-numeric>
                          <label style="padding-right:5px">{{ item.price }}</label>
                        </md-table-cell>
                      </md-table-row>
                    </md-table>
                  </div>
              </md-card>
              <md-card class="main-content" style="margin-top:12px;">
                <md-card-header>
                  <md-card-header-text>
                    <div class="mktops-subheader-text">Condition Sets</div>
                  </md-card-header-text>
                  <md-button class="md-button md-primary" @click="editCampaign(Info._id,3)"  v-if="isOwner  && permit.acl['campaign'].menus['manage'].add == true && !Expired">EDIT</md-button>
                </md-card-header>
                  <md-tabs md-active-tab="tab-0">
                    <md-tab v-for="(item , index) in Info.sets" :key="index" :id="`tab-${index}`" :md-label="item.name">
                        <div class="md-layout-item md-layout md-gutter">
                          <div class="md-layout-item md-size-60" style="padding-left:0px">
                            <div class="md-layout-item md-layout md-gutter">
                              <div class="md-layout-item md-size-30" style="padding-left:0px">
                                  <div class="md-tab-blue-text">Set</div>
                                  <div class="md-tab-text" style="margin-top:3px">{{item.name}}</div>
                              </div>
                              <div class="md-layout-item md-size-70">

                              </div>
                              <div class="md-layout-item md-size-100 rows-item">
                                <div class="mktops-text-condition">Conditions</div>
                              </div>
                                
                              <div class="md-layout-item md-size-100 rows-item" v-if="item.point">
                                <div class="section-sub-line" style="width:300px;">
                                  <label class="mktops-text-qty" style="margin-right:20px;"><b>Point</b></label>
                                  <label class="md-tab-text">{{item.point.end}}</label>
                                </div>
                              </div>




                              <div class="md-layout-item md-size-100 rows-item">
                                <div class="mktops-text-condition">Reward</div>
                              </div>

                              <div class="free-items-box" v-for="(data,index_rewards) in item.rewards" :key="index_rewards">
                                  <div class="md-layout">
                                      <div class="md-layout-item">
                                          <img class="imgItem" :src="data.image">
                                      </div>
                                      <div class="md-layout-item right">
                                          <div class="title">Product Name</div>
                                          <div class="data">{{data.name}}</div>
                                          <div class="title">ESTIMATE COST</div>
                                          <div class="data">{{data.qty}}</div>
                                          <div class="title" v-if="data.sendDate">SEND DATE</div>
                                          <div class="data" v-if="data.sendDate">{{data.sendDate}}</div>
                                      </div>
                                  </div>
                              </div>

                              <!-- <div class="md-layout-item md-size-100 rows-item" v-if="item.badge">
                                <img :src=item.badge.image style="width='100px';height='100px';"/>
                                <div class="section-sub-line">
                                  <label>Badge</label>
                                  <label>{{item.badge.title}}</label>
                                </div>
                              </div> -->
                              <!-- {{item.rewards}}
                              <div v-if="item.rewards != null || item.rewards.length > 0">
                                <div v-for="(reward,index) in item.rewards" :key="index">
                                  <div class="md-layout-item md-size-100 rows-item" v-if="item.rewards">
                                    <img :src=reward.image width="150px" height="150px"/>
                                    <div class="section-sub-line">
                                      <label>Reward</label>
                                      <label>{{reward.title}}</label>
                                    </div>
                                  </div>
                                </div>
                              </div> -->



                            </div>
                          </div>
                          <div class="md-layout-item md-size-40 section-line">
                            <div class="mktops-text-condition">Customer Groups</div>
                            <div class="md-layout filter-chips">
                              <md-chip
                                  style="display: inline-grid;margin-left: 0px;" 
                                  class="md-primary" 
                                  v-for="(customer,index_customer) in item.customers"
                                  :key="`customer_${index_customer}`">
                                  ({{index_customer+1}}) {{customer.group_name}}
                                </md-chip>
                            </div>
                          </div>
                        </div>
                    </md-tab>
                  </md-tabs>
              </md-card>
         </div>
      </md-drawer>

      <md-dialog-confirm
      :md-active.sync="showConfirmRecall"
      md-title="Recall a campaign."
      md-content="Are you sure?"
      md-confirm-text="Confirm"
      md-cancel-text="Cancel"
      @md-confirm="onConfirmRecall" />

    <md-dialog-confirm
      :md-active.sync="showConfirmSendApprove"
      md-title="Send to approve a campaign."
      md-content="Are you sure?"
      md-confirm-text="Confirm"
      md-cancel-text="Cancel"
      @md-confirm="onConfirmSendApprove" />
      
    </div>
</template>
<script>
import router from "@/router";
import moment from "moment-timezone";
export default {
  name: "campaign-info",
  props: {
    dataCampaign: Object
  },
  computed: {
    Info() {
      return this.dataCampaign;
    },
    user() {
      return this.$jwt.decode(localStorage.getItem("token"));
    },
    isOwner(){
      if(this.user.username == this.Info.createby) return true;
      else return false;
    },
    permit() {
      return this.$jwt.decode(localStorage.getItem("token"));
    },
    Expired(){
      if(this.Info.campaign_status == 'Expired') return true;
      else return false
    }

    // promotion(){
    //   //return this.$store.getters['pmmanage/promo_selected']
    // },
  },
  data() {
    return {
      showInfo: false,
      showConfirmRecall: false,
      showConfirmSendApprove: false
    };
  },
  created() {
    // this.renderMonths("create");
  },
  methods: {
    goStep(step) {
      // router.replace('/promotion/create')
      // this.$store.commit('pmcreate/setPromotion',this.promotion)
      // this.$store.commit('pmcreate/setStep', step)
    },
    convertDate(date) {
      return moment(new Date(date)).format('MMM D, YYYY')
    },
    selectedCondition(promo, cond) {
      // let value = {row: promo };
      // if (cond.name == "Delete") {
      //   this.$store.dispatch("pmmanage/deletePromo", value)
      // } else if (cond.name == "Duplicate") {
      //   this.$store.dispatch("pmmanage/duplicatePromo", value)
      // } else if (cond.name == "Track") {
      //   this.$store.dispatch("pmmanage/trackPromo", value)
      // }
    },
    editCampaign(id,step){
      this.showInfo = false;
      this.$emit('editCampaign', this.Info._id, step);
    },
    deleteCampaign(id){
      this.showInfo = false;
      this.$emit('deleteCampaign', this.Info._id);
    },

    duplicateCampaign(id){
      this.showInfo = false;
      this.$emit('duplicateCampaign', this.Info._id);
    },

    sendApproveCampaign(id){
      this.showConfirmSendApprove = true;
    },

    recallCampaign(id){
      this.showConfirmRecall = true;
    },

    onConfirmRecall(){
      this.showInfo = false;
      this.$emit('recallCampaign', this.Info._id);
    },

    onConfirmSendApprove(){
      this.showInfo = false;
      this.$emit('sendToApproveCampaign', this.Info._id);
    }

  }
};
</script>

<style lang="scss">
$color-primary: #3f51b5;
$color-accent: red;
$color-grey: #a8a8a8;
$color-lightgrey: #fafafa;
$color-increase-sales: #52b6b0;
$color-increase-outlets: #5daaec;
$color-new-product: #527de5;
$color-compete: #9a67e3;

$font-Lato: Lato;
$font-Roboto: Roboto;
$font-proxima: Proxima Nova;
$size-brandname: 16px;
$size-menu: 16px;

#md-approve-dialog2 {
  width: 900px;
  z-index: 7;
  background: #f7f7f7;
  overflow: hidden;
  .md-transparent {
    color: #ffffff;
    background-color: #3f51b5;
    .md-icon {
      color: #ffffff;
    }
    .main-title {
      width: 625px;
      padding-top: 8px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      height: 40px;
    }
    .sub-title {
      width: 100px;
      padding-left: 20px;
      text-transform: uppercase;
    }
  }
  .md-card {
    margin: 5px 7px 13px 20px;
    .md-card-header {
      padding: 20px 5px 0 20px;
      .md-card-header-text {
        padding-top: 4px;
      }
      .mktops-subheader-text {
        text-align: unset;
      }
    }
  }
  .mktops-square-blue {
    width: 30px;
    height: 30px;
    background-color: $color-primary;
    border-radius: 4px;
    line-height: 30px;
    text-align: center;
    font-size: 10px;
    margin-top: 8px;
    .md-icon {
      color: #ffffff;
    }
  }
  .md-tabs-navigation {
    padding-left: unset;
    border-bottom: 1px solid #d7d7d7;
  }
  .md-tab {
    padding: 20px;
  }
  .md-tab-text & .md-tab-blue-text {
    font-size: 14px;
  }
  .md-tab-blue-text {
    color: $color-primary;
    font-size: 12px;
  }
  .md-tab-blue-text.table {
    font-weight: 400;
  }
  .rows-item {
    padding-left: 0px;
    margin-top: 16px;
    margin-left:20px;
  }
  .mr-20 {
    margin-right: 20px;
  }
  .mktops-text-condition {
    font-family: Roboto;
    font-weight: 500;
    font-size: 16px;
    color: #000000;
  }
  .mktops-text-qty {
    font-family: Roboto;
    font-size: 16px;
    color: #000000;
  }
  .section-line {
    border-left: 1px solid #d7d7d7;
  }
  .section-sub-line {
    margin-left:5px;
    padding-right:10px;
    border-left: 2px solid #d7d7d7;
    height: 100%;
    width: 5px;
    margin-right: 18px;
  }
  .step-content-line {
    margin-top: 14px;
    display: flex;
    padding-left: 10px;
  }
  .filter-chips {
    margin-top: 7px;
    .md-chip {
      width: 300px;
      margin-top: 3px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      font-size: 12px;
    }
    .md-chip.md-theme-default {
      background-color: #3f51b5;
      color: #ffffff;
    }
  }
  .section-sub {
    margin-top: 14px;
    display: flex;
    padding-left: 10px;
  }
  .mktops-produce-table,
  .mktops-info-table {
    .md-table {
      font-family: $font-Roboto;
      .md-toolbar {
        padding-right: unset;
        border-bottom: 0;
      }
      .md-table-head-label {
        font-size: 12px;
        font-family: $font-Roboto;
      }
      .md-table-fixed-header {
        padding: 0 0 0 13px;
        margin-bottom: 5px;
        margin-top: 7px;
      }
      .md-content.md-table-content.md-scrollbar.md-theme-default {
        .md-table-row {
          .md-table-cell-container {
            padding: 0 5px 0 7px;
          }
        }
      }
    }
  }
  .mktops-produce-table {
    padding-left: 10px;
    padding-bottom: 20px;
    .md-table-head-label {
      color: rgba(0, 0, 0, 0.54);
    }

    tbody .md-table-row td {
      border-top: 0;
      font-size: 13px;
      color: rgba(0, 0, 0, 0.87);
      height: auto;
      padding-top: 8px;
      padding-bottom: 8px;
    }
    .md-table-head-container {
      padding: unset;
      height: 46px;
    }
    .md-table-head-label {
      padding-right: 15px;
      padding-left: 0;
    }
    .md-table-content {
      padding: 0 5px 0 5px;
    }
    .md-scrollbar::-webkit-scrollbar {
      background-color: white !important;
    }
    .md-scrollbar::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.11);
      border-radius: 5px;
    }
    .md-table-cell-description {
      width: 150px;
      .md-table-cell-container {
        width: 99%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .mktops-info-table {
    width: 100%;
    text-align: left;
    margin-bottom: 20px;
    .info-table-content {
      border-top: 0;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.87);
      font-weight: 500;
    }
  }
  .content-md-drawer {
    margin-right: 4px;
    overflow-y: scroll;
    height: calc(100vh - 80px);
  }
  .content-md-drawer::-webkit-scrollbar {
    height: 7px;
    width: 8px;
    background: #f7f7f7;
  }
  .content-md-drawer::-webkit-scrollbar-thumb {
    background-color: #f7f7f7;
    border-radius: 5px;
  }

}

.free-items-box {
  width: 290px;
  height: 180px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  margin-bottom: 10px;

  .right {
    text-align: right;
    padding-right: 10px;

    .title {
      font-size: 10px;
      color: #d9d9d9;
    }

    .data {
      font-size: 16px;
      color: #000;
    }

    .btn-remove {
      font-size: 12px;
      color: red;
    }
  }
  // 	width: calc(350px);
  img {
    height: 150px;
    width: 150px;
    margin-left: 10px;
    margin-top: 10px;
  }
}

.campaign-status-label {
  text-align: center;
  vertical-align: middle;
  padding: 3px;
  width: 50px;
  height: 18px;
  border-radius: 2px;
  font-size: 10px;
  font-family: Roboto;
  font-weight: bold;
  color: white;
  margin-top:5px;

  &.active {
    background: #527de5;
  }
  &.ready {
    background: #30c0da;
  }
  &.pending {
    background: #fcba2f;
  }
  &.draft {
    background: #a8a8a8;
  }
  &.expired {
    background: #e1e1e1;
  }
}
</style>